

<div class="box">
  <canvas #visualiserCanvas (tunResize)="onResizeContainer($event)" class="visualiser"></canvas>
</div>



